import {
  WebAppAuthHandler,
  AppContextGenerator,
  TeamsHubAppAuthHandler,
  TeamsHubSessionIdHandler,
  WebAppSessionIdHandler,
  AppType,
  AppContextType,
  IAuthHandler,
  IHandler,
} from "@microsoft/metaos-appcontextutils";
import msal from "./msal";
import { msalConfig } from "../configs";
import { defaultValue } from "./constants";
import { appInsights } from "./appInsights";

export const initAppContext = async (appType: AppType) => {
  return await AppContextGenerator.getInstance().setAppContextAsync([
    getAuthHandler(appType),
    getSessionIdHandler(appType),
  ]);
};

export const refreshAuthTokenIfRequired = async (appContext: AppContextType) => {
  // Why is this returning new instances of Handlers on every call?
  // This needs to be FIXED!
  return await getAuthHandler(appContext.appType).refreshAuthDataAsync(appContext);
};

const getAuthHandler = (appType: AppType): IAuthHandler => {
  switch (appType) {
    case AppType.placesMetaOs:
      return new TeamsHubAppAuthHandler(appInsights);
    case AppType.standAlone:
    default: {
      const defaultScope: string = msalConfig.auth?.clientId + defaultValue;
      return new WebAppAuthHandler(msal, [defaultScope], appInsights);
    }
  }
};

const getSessionIdHandler = (appType: AppType): IHandler => {
  switch (appType) {
    case AppType.placesMetaOs:
      return new TeamsHubSessionIdHandler(appInsights);
    case AppType.standAlone:
    default:
      return new WebAppSessionIdHandler(msal);
  }
};
